<template>
  <div class="step1 section is-mobile-wider">
    <div class="container has-text-centered">
      <div
        class="coloumn column is-8 is-offset-2 is-12-mobile"
        v-if="isAreaEmpty"
      >
        <article class="message is-danger">
          <div class="message-header">
            <p>
              <span class="icon">
                <i class="mdi mdi-alert-circle mdi-12px"></i>
              </span>
              <!--Verdammt! Aktuell arbeiten wir an unserer Seite!-->
              Verdammt! Aktuell sind alle vorhandenen Flächen schon vergeben.
            </p>
          </div>
          <div class="message-body">
            <p>
              <!--Für voraussichtlich 24 bis 48 Stunden können wir daher leider
              keine Patenschaften verkaufen. Komm doch bitte morgen wieder
              vorbei. Danke für dein Verständnis!-->
              Wir arbeiten fleißig an neuen Flächen. Nächstes Mal haben wir
              bestimmt wieder was für dich!
            </p>
          </div>
        </article>
      </div>
      <div
        class="coloumn column is-8 is-offset-2 is-12-mobile"
        v-if="!isAreaEmpty"
        :class="thickclass"
      >
        <h3 class="subtitle is-4 is-size-5-mobile">
          Wie groß soll deine Blühfläche sein?
        </h3>
        <b-field>
          <b-slider
            size="is-large"
            type="is-info"
            class="spacetop spacebottom"
            v-model="qmslider"
            :custom-formatter="val => val + 'm²'"
            :min="1"
            :max="slidermax"
          >
            <template v-for="val in [5, 25, 50, 100]">
              <b-slider-tick :value="val" :key="val">{{ val }}m²</b-slider-tick>
            </template>
          </b-slider>
        </b-field>
        <div class="content">
          <p class="is-size-6 is-size-7-mobile">
            Du übernimmst eine Patenschaft für
            <span class="has-text-weight-bold"
              >{{ qmslider }}m² Blühfläche</span
            >
            in der Blühsaison 2025 für einen einmaligen Preis von:
            <span class="has-text-weight-bold" name="price">{{
              price | currency
            }}</span>
            (Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.)
          </p>
          <p>
            Dein Zertifikat kannst du dir sofort nach dem Kauf herunterladen,
            zusätzlich bekommst du es in Form einer schönen Karte per Post
            zugeschickt. Außerdem kannst du dich natürlich direkt für unsere
            digitale Bienenpost anmelden, damit du immer weißt, was auf dem Feld
            gerade los ist. Die erste Bienenpost für die Saison 2025 versenden
            wir ungefähr Ende April 2025, nach der ersten Aussaat.
          </p>
        </div>
        <div class="buttons is-right spacetop">
          <b-button
            type="is-primary"
            size="is-large"
            class="is-right"
            @click="forwardstep"
            >zu Schritt 2</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Step1",
  data() {
    return {
      qmslider: 10,
      slidermax: 100, // change value also in created() function
      isAreaEmpty: true,
      thickclass: "showthicks"
    };
  },
  methods: {
    forwardstep() {
      this.$emit("activeStep", 1);
      this.$matomo.trackEvent(
        "Purchaseprocess",
        "Step1",
        "Selected: " + this.qmslider + "m²"
      );
    }
  },
  async created() {
  //  const area = await axios.get("/.netlify/functions/readarea", {
  //    responseType: "json"
  //  });
  //  if (area.status === 200) {
  //    //console.log("Area was read. Available squaremeters: " + area.data.data.Area);
  //    if (area.data.data.Area < 100) {
  //      this.slidermax = area.data.data.Area;
  //      this.thickclass = "hidethicks";
  //    }
  //    if (area.data.data.Area < 1) {
  //      this.isAreaEmpty = true;
  //    }
  //  } else {
  //    //console.log("Could not read area");
  //  }
  this.isAreaEmpty = true
  },
  computed: {
    // Price is alsp calculated in payment functions for verification
    price: function() {
      switch (true) {
        case this.qmslider < 5:
          var pricecalc = Math.round(this.qmslider * 3 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          return pricecalc;
        case this.qmslider < 25:
          var pricecalc = Math.round(this.qmslider * 2 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          return pricecalc;
        case this.qmslider < 50:
          var pricecalc = Math.round(this.qmslider * 1.75 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          return pricecalc;
        case this.qmslider < 100:
          var pricecalc = Math.round(this.qmslider * 1.5 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          return pricecalc;
        case this.qmslider < 150:
          var pricecalc = Math.round(this.qmslider * 1.25 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          return pricecalc;
        default:
          var pricecalc = Math.round(this.qmslider * 1.19 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          return pricecalc;
      }
    }
  }
};
</script>

<style lang="scss">
.b-slider.is-large .b-slider-tick-label {
  top: calc(1.5rem / 2 + 2px) !important;
}

.hidethicks .b-slider-tick-label {
  display: none !important;
}
</style>
